import { Search, CalendarCheck, PlaneLanding, CarFront } from "lucide-react";

const steps = [
  {
    icon: Search,
    title: "Search your route",
    text: "Enter your airport, destination and passengers to get an instant fixed price.",
  },
  {
    icon: CalendarCheck,
    title: "Book in 2 minutes",
    text: "Pay online with PayPal or reserve and pay cash to your driver. Instant voucher by email.",
  },
  {
    icon: PlaneLanding,
    title: "We track your flight",
    text: "Your driver monitors delays and waits up to 60 minutes at no extra cost.",
  },
  {
    icon: CarFront,
    title: "Ride door to door",
    text: "Private vehicle, air conditioning and a direct trip to your hotel, villa or address.",
  },
];

const HowItWorksSection = () => (
  <section className="py-20 bg-background">
    <div className="container mx-auto px-4">
      <div className="max-w-2xl mb-12">
        <p className="text-primary font-sans font-semibold tracking-[0.2em] uppercase text-xs mb-3">
          How it works
        </p>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
          Four steps from booking to arrival
        </h2>
      </div>

      <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((s, i) => (
          <li key={s.title} className="relative rounded-xl border border-border bg-card p-6">
            <span className="absolute top-5 right-5 font-display text-4xl font-bold text-primary/15">
              {i + 1}
            </span>
            <span className="w-11 h-11 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
              <s.icon className="w-5 h-5 text-primary" aria-hidden="true" />
            </span>
            <h3 className="font-sans font-semibold text-card-foreground mb-2">{s.title}</h3>
            <p className="font-sans text-sm text-muted-foreground leading-relaxed">{s.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorksSection;
